// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { TenantViewModel } from '@ail/customers-api'
import { DatabaseReportViewModel, ReportViewModel } from '@ail/reports-api'
import { Component, ReactElement } from 'react'
import DataGrid, { Column } from 'react-data-grid'
import { WithTranslation, withTranslation } from 'react-i18next'
import { ConnectedProps, connect } from 'react-redux'
import { NavLink, RouteComponentProps, withRouter } from 'react-router-dom'
import { Arr } from '../../helpers/Arr'
import { FrontendSettings } from '../../helpers/FrontendSettings'
import { ObjectHelper } from '../../helpers/ObjectHelper'
import { convertContractIdToGUID, defineContractState, printDate } from '../../helpers/Utils'
import { wrapQuery } from '../../redux/api/apiQuery'
import { customersApi } from '../../redux/api/customerApi'
import { isDatabaseReport, reportsApi } from '../../redux/api/reportsApi'
import { State } from '../../redux/reducers/initialState'
import {
  damageTypeValuesDict,
  damagesTranslations,
  indidentStatusTranslations,
  vehicleNatureValuesDictGerman,
} from '../../types/constants'
import { FrontendSettingsKeys } from '../../types/enums'
import { ICarDamageReportData, IReportViewModel, ITenantViewModel } from '../../types/interfaces'
import { Reports } from '../../utils/reports'
import DataSecurityPopup from '../ContractDetails/Popups/DataSecurityPopup'
import ContractsDropDownFilterModal from '../GeneralContracts/ContractsDropDownFilterModal/ContractsDropDownFilterModal'
import TextFieldFilterFormatter from '../GeneralContracts/Formatters/TextFieldFilterFormatter'
import Alert from '../common/Alert/Alert'
import LicencePlateFlag from '../common/LicencePlateFlag/LicencePlateFlag'
import { LoadingSpinner } from '../common/LoadingSpinner/LoadingSpinner'
import Modal from '../common/Modal/Modal'
import './CarDamages.scss'
import { Loader } from '../common/Loader/Loader'

const initialFilters = {
  group: [],
  customerName: [],
  costCenter: [],
  incidentID: '',
  incidentDate: '',
  damageType: [],
  incidentStatus: [],
  contract: '',
  insurance: '',
  licence: '',
  objType: [],
  vehicle: '',
  makes: [],
  model: '',
  contractStatus: [],
}

const intialDamagesCounters: IDamagesCounters[] = [
  { name: 'COLLISION_CAR', amount: 0 },
  { name: 'COLLISION_OBJECT', amount: 0 },
  { name: 'GLASS_BREAKAGE', amount: 0 },
  { name: 'PARKING_DAMAGE', amount: 0 },
  { name: 'DAMAGE_HAIL', amount: 0 },
  { name: 'DAMAGE_MARTENS', amount: 0 },
  { name: 'NO_DAMAGE', amount: 0 },
  { name: 'VANDALISM', amount: 0 },
  { name: 'THEFT', amount: 0 },
  { name: 'COLLISION_ANIMAL', amount: 0 },
  { name: 'NATURAL_HAZARDS', amount: 0 },
  { name: 'COLLISION_PEOPLE', amount: 0 },
]

enum CarDamageGridColEnum {
  group = 'group',
  customerName = 'customerName',
  costCenter = 'costCenter',
  incidentID = 'incidentID',
  incidentDate = 'incidentDate',
  damageType = 'damageType',
  incidentStatus = 'incidentStatus',
  contract = 'contract',
  insurance = 'insurance',
  licence = 'licence',
  objType = 'objType',
  vehicle = 'vehicle',
  makes = 'makes',
  model = 'model',
  contractStatus = 'contractStatus',
}

interface IDamagesCounters {
  name: string
  amount: number
}

interface ICarDamageGridRowItem {
  group: string
  customerName: string
  costCenter: string
  incidentID: string
  incidentDate: Date
  damageType: string
  incidentStatus: string
  contract: string
  contractId: number
  insurance: string
  licence: string
  objType: string
  vehicle: string
  makes: string
  model: string
  contractStatus: string
  endDate: string
}

interface HeaderRendererProps {
  /** image url, used as background-image */
  title: string
  colKey: string
  sortSettings?: ISortSettings
  onSort?: (key: string) => void
  suffix?: () => void
}

interface ISortSettings {
  sortingEnabled?: boolean
  direction: number
  key: string
}

type ICarDamagesProps = ConnectedProps<typeof connector> & WithTranslation & RouteComponentProps

interface ICarDamagesState {
  report?: DatabaseReportViewModel
  availableReports: ReportViewModel[]
  showList: boolean
  loading: boolean
  sourceTenants: ITenantViewModel[]
  tenants: TenantViewModel[]
  showWarningModal: boolean
  damageCounters: IDamagesCounters[]
  damageCountersFiltered: IDamagesCounters[]
  damageTypesForFilters: string[]
  groupsForFilters: string[]
  showDamageTypesModal: boolean
  showIncidentStatusModal: boolean
  filters: Record<string, any>
  conrtactStatusesForFilters: string[]
  incidentStatusForFilters: string[]
  showStatusFilterModal: boolean
  objTypeForFilters: string[]
  customerSearchString: string
  groupSearchString: string
  makesForFilters: string[]
  companiesForFilters: string[]
  allCompanies: string[]
  CCForFilters: string[]
  showMakesSearchModal: boolean
  showCustomerSearchModal: boolean
  showGroupSearchModal: boolean
  showObjTypeSearchModal: boolean
  showCCSearchModal: boolean
  gridCols: Column<ICarDamageGridRowItem>[]
  gridRows: ICarDamageGridRowItem[]
  gridRowsFiltered: ICarDamageGridRowItem[]
  reportData: ICarDamageReportData[] | null
  currentReport: IReportViewModel
  gridSortingSettings: ISortSettings
  reportInvalid: boolean
  selectedTenantId?: string
  pendingExportConfirm?: { onConfirm: () => void }
}

class CarDamages extends Component<ICarDamagesProps, ICarDamagesState> {
  private pollingTimeoutId?: number = undefined
  constructor(props: ICarDamagesProps) {
    super(props)
    this.state = {
      availableReports: [],
      showList: false,
      showIncidentStatusModal: false,
      showWarningModal: false,
      sourceTenants: [],
      tenants: [],
      allCompanies: [],
      incidentStatusForFilters: [],
      loading: false,
      damageCounters: ObjectHelper.clone(intialDamagesCounters),
      damageCountersFiltered: ObjectHelper.clone(intialDamagesCounters),
      damageTypesForFilters: [],
      groupsForFilters: [],
      showDamageTypesModal: false,
      conrtactStatusesForFilters: [],
      showStatusFilterModal: false,
      makesForFilters: [],
      customerSearchString: '',
      groupSearchString: '',
      showGroupSearchModal: false,
      CCForFilters: [],
      objTypeForFilters: [],
      companiesForFilters: [],
      showMakesSearchModal: false,
      showCustomerSearchModal: false,
      showObjTypeSearchModal: false,
      showCCSearchModal: false,
      filters: FrontendSettings.getObject(FrontendSettingsKeys.carDamagesFilters) || initialFilters,
      reportData: null,
      gridCols: [],
      gridRows: [],
      gridRowsFiltered: [],
      gridSortingSettings: {
        sortingEnabled: true,
        direction: 0,
        key: null,
      },
      currentReport: null,
      reportInvalid: false,
    }
    this.filtersApply = this.filtersApply.bind(this)
    this.handleSortingColumn = this.handleSortingColumn.bind(this)
    this.closeCCModal = this.closeCCModal.bind(this)
    this.closeObjTypeModal = this.closeObjTypeModal.bind(this)
    this.closeMakesModal = this.closeMakesModal.bind(this)
    this.closeIncidentStatusModal = this.closeIncidentStatusModal.bind(this)
    this.closeShowStatusFilterModal = this.closeShowStatusFilterModal.bind(this)
    this.closeDamageTypeModal = this.closeDamageTypeModal.bind(this)
    this.closeGroupModal = this.closeGroupModal.bind(this)
  }

  componentDidMount(): void {
    this.props.loadTenants().then((tenants) => this.setState({ tenants }))
    this.props.getAvailableReports().then((availableReports) => {
      this.setState({ availableReports })
    })
  }

  componentDidUpdate(oldProps: Readonly<ICarDamagesProps>, oldState: Readonly<ICarDamagesState>): void {
    const {
      tenants,
      reportData,
      gridSortingSettings,
      filters,
      customerSearchString,
      allCompanies,
      selectedTenantId,
      report,
      availableReports,
    } = this.state

    if (
      allCompanies !== oldState.allCompanies ||
      filters.customerName !== oldState.filters.customerName ||
      customerSearchString !== oldState.customerSearchString
    ) {
      const companies =
        allCompanies.filter(
          (el) => el.toLowerCase().includes(customerSearchString.toLowerCase()) && !filters.customerName.includes(el)
        ) || allCompanies
      this.setState({
        companiesForFilters: companies,
      })
    }

    if (availableReports !== oldState.availableReports || tenants !== oldState.tenants) {
      this.getTenantsList()
    }

    if (selectedTenantId !== oldState.selectedTenantId && selectedTenantId) {
      this.getReportData()
    }

    if (filters !== oldState.filters) {
      FrontendSettings.setObject(FrontendSettingsKeys.carDamagesFilters, filters)
      this.filteredRowsPrepare()
      this.createCols()
    }

    if (this.state.gridRowsFiltered !== oldState.gridRowsFiltered) {
      this.countersUpdate()
    }

    if (gridSortingSettings !== oldState.gridSortingSettings) {
      this.sortGrid()
      this.createCols()
    }

    if (this.props.t !== oldProps.t) {
      this.createCols()
    }

    if (report !== oldState.report && !!report?.data) {
      const reportDataTyped: ICarDamageReportData[] = ObjectHelper.clone(report.data as any)
      this.setState({
        reportData: reportDataTyped,
      })
      this.createCols()
    }

    if (
      this.state.gridRows !== oldState.gridRows &&
      Arr.any(this.state.gridRows) &&
      !ObjectHelper.areEqual(this.state.filters, initialFilters)
    ) {
      this.filteredRowsPrepare()
      this.countersUpdate()
    }

    if (reportData !== oldState.reportData && Arr.any(reportData)) {
      this.setState({
        loading: false,
      })
      this.generateRows()
    }
  }

  render() {
    const {
      filters,
      customerSearchString,
      showCCSearchModal,
      showList,
      CCForFilters,
      objTypeForFilters,
      showObjTypeSearchModal,
      makesForFilters,
      showMakesSearchModal,
      conrtactStatusesForFilters,
      groupsForFilters,
      showGroupSearchModal,
      showStatusFilterModal,
      damageTypesForFilters,
      incidentStatusForFilters,
      showIncidentStatusModal,
      showDamageTypesModal,
    } = this.state
    const { t } = this.props
    return (
      <Loader blocking={this.state.loading}>
        <div className="grid-size">
          <div className="carDamagesParent">
            <div className="carDamagesArea">
              {this.props.currentUser?.isInternalUser && (
                <div className="contractFilters reportFilters internal">
                  <div className="leftContainer">
                    <div className="reqTitle">
                      <span>{t('AVAILABLE_DATA')}</span>
                    </div>
                  </div>
                  <div className="dataSourceSelect">
                    <label>{t('FILTER_BY')}</label>{' '}
                    <div className="perPage">
                      <div className="selectArea">
                        <select
                          value={this.state.selectedTenantId ?? ''}
                          onChange={(e) => this.setState({ selectedTenantId: e.currentTarget.value })}
                        >
                          <option key={''} value={''} disabled></option>
                          {this.state.sourceTenants.map((el) => (
                            <option key={el.id} value={el.id}>
                              {el.name}
                            </option>
                          ))}
                        </select>
                        <i className="icon-bottom" />
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div className="header-filters-example">
                <div className="contractFilters reqFilters">
                  <div className="leftContainer">
                    <div className="reqTitle">
                      <i className="icon-car-damage" />
                      <span>{t('DAMAGES')}</span>
                    </div>
                  </div>
                  <div className="rightFilters">
                    <a onClick={() => this.setState({ pendingExportConfirm: { onConfirm: () => this.download() } })}>
                      <i className="icon-excel"></i>
                      <span>{t('EXPORT_CONTRACT_TO_EXCEL')}</span>
                    </a>
                  </div>
                </div>
              </div>
              <div className="deltaTopArea">
                <div className="col-12">
                  <div className="row">
                    {this.state.damageCountersFiltered.map((el) => (
                      <div className="col-2 col-md-1">
                        <div className={`deltaTopChart damageStats ${el.amount === 0 ? 'empty' : ''}`}>
                          <i className={damageTypeValuesDict[el.name]} />
                          <strong>{t(el.name)}</strong>
                          <div className="damageCounter">
                            <span>{el.amount}</span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="grid-wrap flat-no-paging car-damages">
              <DataGrid
                rowHeight={45}
                columns={this.state.gridCols}
                rows={this.state.gridRowsFiltered}
                headerRowHeight={90}
              />
            </div>
          </div>
          <Modal
            title={t('CUSTOMER_SEARCH')}
            visible={this.state.showCustomerSearchModal}
            onClose={() => {
              this.setState({
                showCustomerSearchModal: false,
                customerSearchString: '',
                showList: false,
              })
            }}
          >
            <div className="customer-name-filter-ui">
              {filters.customerName.length > 0 && (
                <div className="active-items">
                  {filters.customerName.map((c, idx) => (
                    <span key={idx}>
                      <span>{c} </span>
                      <i className="icon-close" onClick={() => this.applyCustomer(c)} />
                    </span>
                  ))}
                </div>
              )}
              {filters.customerName.length > 0 && (
                <div className="activeFilter">
                  <span>
                    {filters.customerName.length} {t('SELECTED')}
                  </span>
                  <a
                    onClick={() =>
                      this.setState({
                        filters: {
                          ...this.state.filters,
                          customerName: [],
                        },
                      })
                    }
                  >
                    <i className="icon-clear" /> {t('CLEAR_SELECTED')}
                  </a>
                </div>
              )}
              <div className="search">
                <input
                  autoFocus={true}
                  type="text"
                  value={customerSearchString}
                  name={`fieldnameveryunique${new Date().getTime()}`}
                  autoComplete="none"
                  list="autocompleteOff"
                  placeholder={t('CUSTOMER_KEYWORDS')}
                  onClick={() => this.setState({ showList: true })}
                  onChange={(e) => this.setState({ customerSearchString: e.target.value })}
                />
                <i
                  className={`icon-${showList ? 'up' : 'bottom'}`}
                  onClick={() => this.setState({ showList: !showList })}
                />
                <i className="icon-search" />
              </div>
              {showList && (
                <div className="search-results">
                  <div className="resultsArea">
                    <ul>
                      {this.state.companiesForFilters
                        .filter((c) => {
                          return (
                            filters.customerName.filter((el) => {
                              return el === c
                            }).length === 0 &&
                            (!customerSearchString ||
                              (!!customerSearchString &&
                                c?.toLowerCase().indexOf(customerSearchString?.toLowerCase()) >= 0))
                          )
                        })
                        .map((c, idx) => (
                          <li key={idx} onClick={() => this.applyCustomer(c)}>
                            <span className="name cardmg">{c}</span>
                          </li>
                        ))}
                    </ul>
                    <div className="searchFilters">{this.state.companiesForFilters.length} results</div>
                  </div>
                </div>
              )}
              <div className="btnArea">
                <div>
                  <button
                    title={t('APPLY')}
                    onClick={() => {
                      this.setState({ showCustomerSearchModal: false })
                    }}
                  >
                    {t('APPLY')}
                  </button>
                </div>
              </div>
            </div>
          </Modal>
          <Modal
            title={t('WARNING')}
            visible={this.state.showWarningModal}
            onClose={() => {
              this.props.history.push('/')
            }}
          >
            <h5>{t('FAILED_REPORT_MESSAGE')}</h5>
          </Modal>
          <ContractsDropDownFilterModal
            title={t('COST_CENTER_SEARCH')}
            allItems={CCForFilters}
            visible={showCCSearchModal}
            currentFilter={filters.costCenter}
            filterChanged={(newItems) => {
              this.setState({
                filters: {
                  ...filters,
                  costCenter: newItems,
                },
              })
            }}
            onClose={this.closeCCModal}
          />
          <ContractsDropDownFilterModal
            title={t('OBJ_TYPE')}
            allItems={objTypeForFilters}
            visible={showObjTypeSearchModal}
            currentFilter={filters.objType}
            filterChanged={(newItems) => {
              this.setState({
                filters: {
                  ...filters,
                  objType: newItems,
                },
              })
            }}
            onClose={this.closeObjTypeModal}
          />
          <ContractsDropDownFilterModal
            title={t('MAKES')}
            allItems={makesForFilters}
            visible={showMakesSearchModal}
            currentFilter={filters.makes}
            filterChanged={(newItems) => {
              this.setState({
                filters: {
                  ...filters,
                  makes: newItems,
                },
              })
            }}
            onClose={this.closeMakesModal}
          />
          <ContractsDropDownFilterModal
            title={t('STATUS_SEARCH')}
            allItems={conrtactStatusesForFilters}
            visible={showStatusFilterModal}
            currentFilter={filters.contractStatus}
            filterChanged={(newItems) => {
              this.setState({
                filters: {
                  ...filters,
                  contractStatus: newItems,
                },
              })
            }}
            translationPrefix={'CONTRACT_'}
            onClose={this.closeShowStatusFilterModal}
          />
          <ContractsDropDownFilterModal
            title={t('DAMAGE_TYPE')}
            allItems={damageTypesForFilters}
            visible={showDamageTypesModal}
            currentFilter={filters.damageType}
            filterChanged={(newItems) => {
              this.setState({
                filters: {
                  ...filters,
                  damageType: newItems,
                },
              })
            }}
            onClose={this.closeDamageTypeModal}
          />
          <ContractsDropDownFilterModal
            title={t('GROUP')}
            allItems={groupsForFilters}
            visible={showGroupSearchModal}
            currentFilter={filters.group}
            filterChanged={(newItems) => {
              this.setState({
                filters: {
                  ...filters,
                  group: newItems,
                },
              })
            }}
            onClose={this.closeGroupModal}
          />
          <ContractsDropDownFilterModal
            title={t('INCIDENT_STATUS')}
            allItems={incidentStatusForFilters}
            visible={showIncidentStatusModal}
            currentFilter={filters.incidentStatus}
            filterChanged={(newItems) => {
              this.setState({
                filters: {
                  ...filters,
                  incidentStatus: newItems,
                },
              })
            }}
            onClose={this.closeIncidentStatusModal}
          />
          {this.props.currentUser?.isAdmin && (
            <Alert
              visible={this.state.reportInvalid}
              title="WARNING"
              onClose={() => {
                this.setState({ reportInvalid: false })
              }}
              message="Report data format is incorrect. Some fields may be missing data"
            />
          )}
          <DataSecurityPopup
            onConfirm={() => {
              this.state.pendingExportConfirm?.onConfirm()
              this.setState({ pendingExportConfirm: undefined })
            }}
            onClose={() => this.setState({ pendingExportConfirm: undefined })}
            visible={!!this.state.pendingExportConfirm}
          />
        </div>
      </Loader>
    )
  }

  private download() {
    const report = this.state.report
    if (!report) return
    Reports.exportDatabaseReport(report)
  }

  private closeDamageTypeModal() {
    this.setState({ showDamageTypesModal: false })
  }

  private closeGroupModal() {
    this.setState({ showGroupSearchModal: false })
  }

  private closeShowStatusFilterModal() {
    this.setState({ showStatusFilterModal: false })
  }

  private closeMakesModal() {
    this.setState({ showMakesSearchModal: false })
  }

  private closeObjTypeModal() {
    this.setState({ showObjTypeSearchModal: false })
  }

  private closeCCModal() {
    this.setState({ showCCSearchModal: false })
  }

  private closeIncidentStatusModal() {
    this.setState({ showIncidentStatusModal: false })
  }

  private applyCustomer(c: string) {
    const customers = [...this.state.filters.customerName]
    if (customers.includes(c)) {
      customers.splice(customers.indexOf(c), 1)
    } else {
      customers.push(c)
    }
    this.setState({
      customerSearchString: '',
      filters: {
        ...this.state.filters,
        customerName: customers,
      },
    })
  }

  private filtersApply(filters: any) {
    this.setState({
      filters,
    })
  }

  private createCols() {
    const { t } = this.props
    const rawGridCols = [
      {
        name: t('GROUP'),
        width: 170,
        key: CarDamageGridColEnum.group,
        headerCellClass: 'car-damages-header',
        renderHeaderCell: () => (
          <>
            {this.GridHeaderFormatter({
              title: t('GROUP'),
              colKey: CarDamageGridColEnum.group,
              onSort: this.handleSortingColumn,
              sortSettings: this.state.gridSortingSettings,
            })}
            {this.filterJSX(this.state.filters.group, CarDamageGridColEnum.group, 'showGroupSearchModal')}
          </>
        ),

        renderCell: (rowProps) => {
          return <div>{rowProps.row?.group}</div>
        },
      },
      {
        name: t('CUSTOMER_NAME'),
        key: CarDamageGridColEnum.customerName,
        headerCellClass: 'car-damages-header',
        renderHeaderCell: () => (
          <>
            {this.GridHeaderFormatter({
              title: t('CUSTOMER_NAME'),
              colKey: CarDamageGridColEnum.customerName,
              onSort: this.handleSortingColumn,
              sortSettings: this.state.gridSortingSettings,
            })}
            {this.filterJSX(
              this.state.filters.customerName,
              CarDamageGridColEnum.customerName,
              'showCustomerSearchModal'
            )}
          </>
        ),

        renderCell: (rowProps) => {
          return <div>{rowProps.row?.customerName}</div>
        },
      },
      {
        name: t('COST_CENTER'),
        width: 120,
        key: CarDamageGridColEnum.costCenter,
        headerCellClass: 'car-damages-header',
        renderHeaderCell: () => (
          <>
            {this.GridHeaderFormatter({
              title: t('COST_CENTER'),
              colKey: CarDamageGridColEnum.costCenter,
              onSort: this.handleSortingColumn,
              sortSettings: this.state.gridSortingSettings,
            })}
            {this.filterJSX(this.state.filters.costCenter, CarDamageGridColEnum.costCenter, 'showCCSearchModal')}
          </>
        ),
        formatter: (rowProps) => {
          return <div>{rowProps.row?.costCenter}</div>
        },
      },
      {
        name: t('INCIDENT_ID'),
        width: 110,
        key: CarDamageGridColEnum.incidentID,
        headerCellClass: 'car-damages-header',
        renderHeaderCell: () => (
          <>
            {this.GridHeaderFormatter({
              title: t('INCIDENT_ID'),
              colKey: CarDamageGridColEnum.incidentID,
              onSort: this.handleSortingColumn,
              sortSettings: this.state.gridSortingSettings,
            })}
            {this.gridTextFilterFormatter(CarDamageGridColEnum.incidentID)}
          </>
        ),
        renderCell: (rowProps) => {
          return <div>{rowProps.row?.incidentID}</div>
        },
      },
      {
        name: t('INCIDENT_DATE'),
        width: 110,
        key: CarDamageGridColEnum.incidentDate,
        headerCellClass: 'car-damages-header',
        renderHeaderCell: (p) => (
          <>
            {this.GridHeaderFormatter({
              title: t('INCIDENT_DATE'),
              colKey: CarDamageGridColEnum.incidentDate,
              onSort: this.handleSortingColumn,
              sortSettings: this.state.gridSortingSettings,
            })}
            {this.gridTextFilterFormatter(CarDamageGridColEnum.incidentDate)}
          </>
        ),
        renderCell: (rowProps) => {
          return <div>{printDate(rowProps.row?.incidentDate)}</div>
        },
      },
      {
        name: t('DAMAGE_TYPE'),
        width: 110,
        key: CarDamageGridColEnum.damageType,
        headerCellClass: 'car-damages-header',
        renderHeaderCell: () => {
          const damageTypesFromFilter =
            this.state.filters?.damageType?.map((el) => t(`${el}`.toUpperCase())).join(', ') || ''
          return (
            <>
              {this.GridHeaderFormatter({
                title: t('DAMAGE_TYPE'),
                colKey: CarDamageGridColEnum.damageType,
                onSort: this.handleSortingColumn,
                sortSettings: this.state.gridSortingSettings,
              })}
              {this.filterJSX(damageTypesFromFilter, CarDamageGridColEnum.damageType, 'showDamageTypesModal')}
            </>
          )
        },
        renderCell: (rowProps) => {
          return (
            <div className="objTypeCell">
              {damageTypeValuesDict[rowProps.row?.damageType] ? (
                <i
                  title={t(rowProps.row?.damageType)}
                  style={{ fontSize: '30px' }}
                  className={damageTypeValuesDict[rowProps.row?.damageType]}
                />
              ) : (
                <label>{rowProps.row?.damageType}</label>
              )}
            </div>
          )
        },
      },
      {
        name: t('INCIDENT_STATUS'),
        width: 130,
        key: CarDamageGridColEnum.incidentStatus,
        headerCellClass: 'car-damages-header',
        renderHeaderCell: () => {
          const incidentStatusFromFilter =
            this.state.filters?.incidentStatus?.map((el) => t(`${el}`.toUpperCase())).join(', ') || ''
          return (
            <>
              {this.GridHeaderFormatter({
                title: t('INCIDENT_STATUS'),
                colKey: CarDamageGridColEnum.incidentStatus,
                onSort: this.handleSortingColumn,
                sortSettings: this.state.gridSortingSettings,
              })}{' '}
              {this.filterJSX(incidentStatusFromFilter, CarDamageGridColEnum.incidentStatus, 'showIncidentStatusModal')}
            </>
          )
        },
        renderCell: (rowProps) => {
          return (
            <label
              className={`contractListStatus statusArea CDincident${rowProps?.row?.incidentStatus?.toLowerCase()}`}
              title={t(rowProps.row?.incidentStatus)}
            >
              {t(rowProps.row?.incidentStatus)}
            </label>
          )
        },
      },
      {
        name: t('CONTRACT'),
        width: 110,
        key: CarDamageGridColEnum.contract,
        headerCellClass: 'car-damages-header',
        renderHeaderCell: (p) => (
          <>
            {this.GridHeaderFormatter({
              title: t('CONTRACT'),
              colKey: CarDamageGridColEnum.contract,
              onSort: this.handleSortingColumn,
              sortSettings: this.state.gridSortingSettings,
            })}
            {this.gridTextFilterFormatter(CarDamageGridColEnum.contract)}
          </>
        ),
        renderCell: (rowProps) => {
          return (
            <NavLink to={`/generalContracts/details/${convertContractIdToGUID(rowProps.row?.contractId)}`}>
              {rowProps.row?.contract}
            </NavLink>
          )
        },
      },
      {
        name: t('INSURANCE'),
        width: 110,
        key: CarDamageGridColEnum.insurance,
        headerCellClass: 'car-damages-header',
        renderHeaderCell: (p) => (
          <>
            {this.GridHeaderFormatter({
              title: t('INSURANCE'),
              colKey: CarDamageGridColEnum.insurance,
              onSort: this.handleSortingColumn,
              sortSettings: this.state.gridSortingSettings,
            })}
            {this.gridTextFilterFormatter(CarDamageGridColEnum.insurance)}
          </>
        ),
        renderCell: (rowProps) => {
          return (
            <div className="flex">
              <i className="icon-liability" />
              {rowProps.row?.insurance}
            </div>
          )
        },
      },
      {
        name: t('LICENSE_NUMBER'),
        width: 120,
        key: CarDamageGridColEnum.licence,
        headerCellClass: 'car-damages-header',
        renderHeaderCell: (p) => (
          <>
            {this.GridHeaderFormatter({
              title: t('LICENSE_NUMBER'),
              colKey: CarDamageGridColEnum.licence,
              onSort: this.handleSortingColumn,
              sortSettings: this.state.gridSortingSettings,
            })}
            {this.gridTextFilterFormatter(CarDamageGridColEnum.licence)}
          </>
        ),
        renderCell: (rowProps) => {
          return (
            rowProps.row.licence && <LicencePlateFlag licenceNumber={rowProps.row.licence} width="12" height="14" />
          )
        },
      },
      {
        name: t('OBJ_TYPE'),
        width: 80,
        key: CarDamageGridColEnum.objType,
        headerCellClass: 'car-damages-header',
        renderHeaderCell: () => {
          const natureFromFilter = this.state.filters?.objType?.map((el) => t(`${el}`.toUpperCase())).join(', ') || ''
          return (
            <>
              {this.GridHeaderFormatter({
                title: t('OBJ_TYPE'),
                colKey: CarDamageGridColEnum.objType,
                onSort: this.handleSortingColumn,
                sortSettings: this.state.gridSortingSettings,
              })}
              {this.filterJSX(natureFromFilter, CarDamageGridColEnum.objType, 'showObjTypeSearchModal')}
            </>
          )
        },
        renderCell: (rowProps) => {
          return (
            <div className="objTypeCell">
              <i className={vehicleNatureValuesDictGerman[rowProps.row.objType] || 'icon-4u'} />
            </div>
          )
        },
      },
      {
        name: t('MAKES'),
        minWidth: 341,
        key: CarDamageGridColEnum.vehicle,
        headerCellClass: 'car-damages-header',
        renderHeaderCell: (p) => (
          <div className="vehicleCol">
            <div className="makesHeader">
              {this.GridHeaderFormatter({
                title: t('MAKES'),
                colKey: CarDamageGridColEnum.makes,
                onSort: this.handleSortingColumn,
                sortSettings: this.state.gridSortingSettings,
              })}
              {this.filterJSX(this.state.filters.makes, CarDamageGridColEnum.makes, 'showMakesSearchModal')}
            </div>
            <div className="modelHeader">
              {this.GridHeaderFormatter({
                title: t('MODEL'),
                colKey: CarDamageGridColEnum.model,
                onSort: this.handleSortingColumn,
                sortSettings: this.state.gridSortingSettings,
              })}
              {this.gridTextFilterFormatter(CarDamageGridColEnum.model)}
            </div>
          </div>
        ),
        renderCell: (rowProps) => {
          if (rowProps.row.makes && rowProps.row.makes.length >= 2) {
            const logos =
              rowProps.row.makes?.toLowerCase().indexOf('ladestation') > -1
                ? 'dummy'
                : rowProps.row.makes?.replace(/\s+/g, '-')?.toLowerCase()
            return (
              <div className="vehicleDescription">
                {logos && (
                  <img
                    src={`../../../../BW/${logos.normalize('NFD').replace(/[\u0300-\u036f]/g, '')}.svg`}
                    width="23"
                    height="23"
                  />
                )}
                {rowProps.row.vehicle}
              </div>
            )
          }
          return null
        },
      },
      {
        name: t('CONTRACT_STATUS'),
        width: 120,
        key: CarDamageGridColEnum.contractStatus,
        headerCellClass: 'car-damages-header',
        renderHeaderCell: () => (
          <>
            {this.GridHeaderFormatter({
              title: t('CONTRACT_STATUS'),
              colKey: CarDamageGridColEnum.contractStatus,
              onSort: this.handleSortingColumn,
              sortSettings: this.state.gridSortingSettings,
            })}
            {this.filterJSX(
              this.state.filters.contractStatus,
              CarDamageGridColEnum.contractStatus,
              'showStatusFilterModal'
            )}
          </>
        ),
        renderCell: (rowProps) => {
          return rowProps.row.contractStatus ? (
            <label
              className={`contractListStatus statusArea CDcontract${rowProps.row.contractStatus?.toLowerCase()}`}
              title={t(`CONTRACT_${rowProps.row.contractStatus}`.toUpperCase())}
            >
              {t(`CONTRACT_${rowProps.row.contractStatus}`.toUpperCase())}
            </label>
          ) : null
        },
      },
    ]
    let gridCols = []
    gridCols = rawGridCols
    this.setState({
      gridCols,
    })
  }

  private handleSortingColumn(key: string) {
    const specSortingSettings = this.state.gridSortingSettings

    const drections = {
      '1': -1,
      '-1': 0,
      '0': 1,
    }
    const direction = key === specSortingSettings?.key ? drections[specSortingSettings?.direction?.toString()] : 1
    this.setState({
      gridSortingSettings: {
        ...specSortingSettings,
        direction,
        key,
      },
    })
  }

  private rowFilteringFunction(
    activeFilterKeys: string[],
    lowercaseFilters: { [id: string]: any },
    r: ICarDamageGridRowItem
  ): boolean {
    return activeFilterKeys
      .map((key) => {
        const currentField = r[key]
        if (Array.isArray(lowercaseFilters[key])) {
          const arr = lowercaseFilters[key] as any[]
          return typeof currentField === 'string'
            ? arr.filter((filter) => currentField?.toLowerCase() === filter).length > 0
            : arr.filter((filter) => currentField === filter).length > 0
        } else {
          return (currentField || '').toString()?.toLowerCase().indexOf(lowercaseFilters[key]) > -1
        }
      })
      .reduce((prev, next) => prev && next, true)
  }

  private rowFilteringFunctionFlat(
    activeFilterKeys: string[],
    lowercaseFilters: { [id: string]: any },
    r: ICarDamageGridRowItem
  ): boolean {
    return this.rowFilteringFunction(activeFilterKeys, lowercaseFilters, r)
  }

  private countersUpdate() {
    const { filters } = this.state
    const countersSource = ObjectHelper.clone(this.state.damageCounters)
    const filteredCounters = countersSource.map((el) => {
      if (!ObjectHelper.areEqual(this.state.filters, initialFilters)) {
        if (
          Arr.any(filters.group) &&
          !Arr.any(filters.customerName) &&
          !Arr.any(filters.costCenter) &&
          !Arr.any(filters.damageType)
        ) {
          el.amount =
            this.state.gridRows.filter((q) => q.damageType === el.name && filters.group.includes(q.group)).length || 0
        }
        if (
          Arr.any(filters.group) &&
          Arr.any(filters.customerName) &&
          !Arr.any(filters.costCenter) &&
          !Arr.any(filters.damageType)
        ) {
          el.amount =
            this.state.gridRows.filter(
              (q) =>
                q.damageType === el.name &&
                filters.customerName.includes(q.customerName) &&
                filters.group.includes(q.group)
            ).length || 0
        }
        if (
          Arr.any(filters.group) &&
          Arr.any(filters.customerName) &&
          Arr.any(filters.costCenter) &&
          !Arr.any(filters.damageType)
        ) {
          el.amount =
            this.state.gridRows.filter(
              (q) =>
                q.damageType === el.name &&
                filters.group.includes(q.group) &&
                filters.customerName.includes(q.customerName) &&
                filters.costCenter.includes(q.costCenter)
            ).length || 0
        }
        if (
          Arr.any(filters.group) &&
          Arr.any(filters.customerName) &&
          Arr.any(filters.costCenter) &&
          Arr.any(filters.damageType)
        ) {
          el.amount =
            this.state.gridRows.filter(
              (q) =>
                q.damageType === el.name &&
                filters.damageType.includes(q.damageType) &&
                filters.group.includes(q.group) &&
                filters.customerName.includes(q.customerName)
            ).length || 0
        }
        if (
          !Arr.any(filters.group) &&
          Arr.any(filters.customerName) &&
          !Arr.any(filters.costCenter) &&
          !Arr.any(filters.damageType)
        ) {
          el.amount =
            this.state.gridRows.filter((q) => q.damageType === el.name && filters.customerName.includes(q.customerName))
              .length || 0
        }
        if (
          !Arr.any(filters.group) &&
          Arr.any(filters.customerName) &&
          Arr.any(filters.costCenter) &&
          !Arr.any(filters.damageType)
        ) {
          el.amount =
            this.state.gridRows.filter(
              (q) =>
                q.damageType === el.name &&
                filters.customerName.includes(q.customerName) &&
                filters.costCenter.includes(q.costCenter)
            ).length || 0
        }
        if (
          !Arr.any(filters.group) &&
          Arr.any(filters.customerName) &&
          Arr.any(filters.costCenter) &&
          Arr.any(filters.damageType)
        ) {
          el.amount =
            this.state.gridRows.filter(
              (q) =>
                q.damageType === el.name &&
                filters.customerName.includes(q.customerName) &&
                filters.costCenter.includes(q.costCenter) &&
                filters.damageType.includes(q.damageType)
            ).length || 0
        }
        if (
          !Arr.any(filters.group) &&
          !Arr.any(filters.customerName) &&
          Arr.any(filters.costCenter) &&
          !Arr.any(filters.damageType)
        ) {
          el.amount =
            this.state.gridRows.filter((q) => q.damageType === el.name && filters.costCenter.includes(q.costCenter))
              .length || 0
        }
        if (
          !Arr.any(filters.group) &&
          !Arr.any(filters.customerName) &&
          Arr.any(filters.costCenter) &&
          Arr.any(filters.damageType)
        ) {
          el.amount =
            this.state.gridRows.filter(
              (q) =>
                q.damageType === el.name &&
                filters.costCenter.includes(q.costCenter) &&
                filters.damageType.includes(q.damageType)
            ).length || 0
        }
        if (
          !Arr.any(filters.group) &&
          !Arr.any(filters.customerName) &&
          !Arr.any(filters.costCenter) &&
          Arr.any(filters.damageType)
        ) {
          el.amount =
            this.state.gridRows.filter((q) => q.damageType === el.name && filters.damageType.includes(q.damageType))
              .length || 0
        }
      }
      return el
    })
    this.setState({
      damageCountersFiltered: filteredCounters,
    })
  }

  private filteredRowsPrepare() {
    const { filters, gridRows } = this.state
    const activeFilterKeys = Object.keys(filters).filter((key) => {
      if (Array.isArray(filters[key])) {
        return filters[key].length > 0
      }
      return filters[key]
    })
    const lowercaseFilters: { [id: string]: any } = {}
    activeFilterKeys.forEach((key) => {
      if (Array.isArray(filters[key])) {
        lowercaseFilters[key] = filters[key].map((item) =>
          typeof item === 'string' ? item.toString()?.toLowerCase() : item
        )
      } else {
        lowercaseFilters[key] = filters[key].toString()?.toLowerCase()
      }
    })

    const filtered = []
    filtered.push(...gridRows?.filter((r) => this.rowFilteringFunctionFlat(activeFilterKeys, lowercaseFilters, r)))
    this.setState({
      gridRowsFiltered: filtered,
    })
  }

  private sortGrid() {
    const { gridSortingSettings, gridRowsFiltered } = this.state
    const numbericSortingColumns = [CarDamageGridColEnum.incidentDate]
    const numericSorting = numbericSortingColumns.indexOf(gridSortingSettings.key as CarDamageGridColEnum) >= 0

    const sorted =
      gridSortingSettings.key && gridSortingSettings.direction !== 0
        ? gridRowsFiltered.sort((a, b) => {
            const valA = a[gridSortingSettings.key]
            const valB = b[gridSortingSettings.key]
            return (numericSorting ? valA - valB : ('' + valA).localeCompare(valB)) * gridSortingSettings.direction
          })
        : gridRowsFiltered.sort((a, b) => b.incidentDate.getTime() - a.incidentDate.getTime())
    this.setState({
      gridRowsFiltered: sorted,
    })
  }

  private gridTextFilterFormatter(target) {
    return (
      <TextFieldFilterFormatter
        onChange={(value) => {
          this.setState({
            filters: {
              ...this.state.filters,
              [target]: value,
            },
          })
        }}
        resetPage={() => {}}
        isNumeric={false}
      />
    )
  }

  private GridHeaderFormatter({ title, colKey, sortSettings, onSort }: HeaderRendererProps) {
    const sortDirection =
      sortSettings.key !== colKey || sortSettings.direction === 0 ? '0' : sortSettings.direction.toString()
    const sortDirectionMap = {
      '1': '-up',
      '0': '',
      '-1': '-down',
    }
    return (
      <div className="rdg-header-cell-wrapper">
        <div
          className={`rdg-header-cell${' sortable'}`}
          onClick={() => {
            onSort(colKey)
          }}
        >
          <>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <span style={{ lineHeight: '17px' }}>{title}</span>
            </div>
            <i className={`icon-sort${sortDirectionMap[sortDirection]} sort`} />
          </>
        </div>
      </div>
    )
  }

  private filterJSX(filtersProp, target, modalToOpen?: string): ReactElement {
    const { t } = this.props
    return (
      <div className="rdg-filter-container">
        <div className="input-area">
          <input
            type="text"
            placeholder=" "
            className="rdg-filter transparent"
            name={`fieldnameveryunique${new Date().getTime()}`}
            autoComplete="none"
            list="autocompleteOff"
            readOnly={true}
            title={filtersProp}
            value={filtersProp}
            onClick={(e) => this.setState({ ...this.state, [modalToOpen]: true })}
          />
          <button
            title={t('CLEAR')}
            className="clr-btn"
            onClick={(e) => {
              this.setState({
                filters: {
                  ...this.state.filters,
                  [target]: initialFilters[target],
                },
              })
            }}
          >
            <span className="icon-clear" />
          </button>
        </div>
      </div>
    )
  }
  private ttGridHeaderFormatter({
    title,
    colKey,
    sortSettings,
    onSort,
    children,
  }: HeaderRendererProps & { children: ReactElement }) {
    const sortDirection =
      sortSettings.key !== colKey || sortSettings.direction === 0 ? '0' : sortSettings.direction.toString()
    const sortDirectionMap = {
      '1': '-up',
      '0': '',
      '-1': '-down',
    }
    return (
      <div className="rdg-header-cell-wrapper">
        <div
          className={`rdg-header-cell${' sortable'}`}
          onClick={() => {
            onSort(colKey)
          }}
        >
          <>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <span style={{ lineHeight: '17px' }}>{title}</span>
            </div>
            <i className={`icon-sort${sortDirectionMap[sortDirection]} sort`} />
            {children}
          </>
        </div>
      </div>
    )
  }

  private hasRequiredFields(data: any): boolean {
    const requiredFields = [
      'CONTRACT_ID',
      'CHASSISNUMMER',
      'CONTRACTSTATE_ENUMID',
      'CUSTOMER_ID',
      'FAHRZEUGART',
      'FAHRZEUGBESCHREIBUNG',
      'FAHRZEUGMARKE',
      'INCIDENTSTATUS_ENUMID',
      'KENNZEICHEN',
      'KONZERN',
      'KUNDE',
      'ROOT_ID',
      'SCHADENSDATUM',
      'SCHADENSNUMMER',
      'SCHADENSTATUS',
      'VERSICHERUNGSART',
      'VERTRAGSENDE',
      'VERTRAGSNUMMER',
      'VERTRAGSSTART',
      'VERTRAGSSTATUS',
    ]

    return requiredFields.every((field) => field in data)
  }

  private generateRows() {
    const gridRows: ICarDamageGridRowItem[] = []
    const customersForFilters: string[] = []
    const CCForFilters: string[] = []
    const groupsForFIlters: string[] = []
    const incidentStatusForFilters: string[] = []
    const onjTypeForFilters: string[] = []
    const makesForFilters: string[] = []
    const contractStatusesForFilters: string[] = []
    const damageTypesForFilters: string[] = []
    const damageCounters: IDamagesCounters[] = ObjectHelper.clone(this.state.damageCounters)
    const expiringDays = Number(FrontendSettings.get(FrontendSettingsKeys.expiringDaysFilter) ?? 90)
    this.state.reportData.forEach((r) => {
      if (ObjectHelper.areEqual(this.state.damageCounters, intialDamagesCounters)) {
        damageCounters.filter((el) => {
          if (el.name === damagesTranslations[r.SCHADENSART]) {
            el.amount += 1
          }
        })
      }

      if (!this.hasRequiredFields(r)) {
        this.setState({ reportInvalid: true })
      }

      if (!!r.KUNDE && !customersForFilters?.includes(r.KUNDE)) {
        customersForFilters.push(r.KUNDE)
      }
      if (!!r.KOSTENSTELLE && !CCForFilters?.includes(r.KOSTENSTELLE)) {
        CCForFilters.push(r.KOSTENSTELLE)
      }
      if (!!r.KONZERN && !groupsForFIlters?.includes(r.KONZERN)) {
        groupsForFIlters.push(r.KONZERN)
      }
      if (!!r.FAHRZEUGART && !onjTypeForFilters?.includes(r.FAHRZEUGART)) {
        onjTypeForFilters.push(r.FAHRZEUGART)
      }
      if (!!r.FAHRZEUGMARKE && !makesForFilters?.includes(r.FAHRZEUGMARKE)) {
        makesForFilters.push(r.FAHRZEUGMARKE)
      }
      if (
        !!r.VERTRAGSSTATUS &&
        !contractStatusesForFilters?.includes(
          defineContractState(null, r.VERTRAGSSTATUS, new Date(r.VERTRAGSENDE), expiringDays)
        )
      ) {
        contractStatusesForFilters.push(
          defineContractState(null, r.VERTRAGSSTATUS, new Date(r.VERTRAGSENDE), expiringDays)
        )
      }
      if (!damageTypesForFilters?.includes(damagesTranslations[r.SCHADENSART])) {
        if (!!damagesTranslations[r.SCHADENSART]) {
          damageTypesForFilters.push(damagesTranslations[r.SCHADENSART])
        } else if (!damageTypesForFilters?.includes(r.SCHADENSART)) {
          damageTypesForFilters.push(r.SCHADENSART)
        }
      }
      if (!!r.SCHADENSTATUS && !incidentStatusForFilters?.includes(indidentStatusTranslations[r.SCHADENSTATUS])) {
        if (!!indidentStatusTranslations[r.SCHADENSTATUS]) {
          incidentStatusForFilters.push(indidentStatusTranslations[r.SCHADENSTATUS])
        } else if (!incidentStatusForFilters?.includes(r.SCHADENSTATUS)) {
          incidentStatusForFilters.push(r.SCHADENSTATUS)
        }
      }
      gridRows.push({
        group: r.KONZERN,
        customerName: r.KUNDE,
        costCenter: r.KOSTENSTELLE,
        incidentID: r.SCHADENSNUMMER + '',
        incidentDate: new Date(r.SCHADENSDATUM),
        damageType: damagesTranslations[r.SCHADENSART] || r.SCHADENSART,
        incidentStatus: indidentStatusTranslations[r.SCHADENSTATUS] || r.SCHADENSTATUS,
        contract: r.VERTRAGSNUMMER,
        contractId: r.CONTRACT_ID,
        insurance: r.VERSICHERUNGSART,
        licence: r.KENNZEICHEN,
        objType: r.FAHRZEUGART,
        vehicle: r.FAHRZEUGBESCHREIBUNG,
        makes: r.FAHRZEUGMARKE,
        model: r.FAHRZEUGBESCHREIBUNG,
        contractStatus: defineContractState(null, r.VERTRAGSSTATUS, new Date(r.VERTRAGSENDE), expiringDays),
        endDate: r.VERTRAGSENDE,
      })
    })
    gridRows.sort((a, b) => b.incidentDate.getTime() - a.incidentDate.getTime())
    this.setState({
      gridRows: gridRows,
      gridRowsFiltered: gridRows,
      allCompanies: customersForFilters.sort((a, b) => a.localeCompare(b)),
      companiesForFilters: customersForFilters.sort((a, b) => a.localeCompare(b)),
      CCForFilters: CCForFilters.sort((a, b) => a.localeCompare(b)),
      groupsForFilters: groupsForFIlters.sort((a, b) => a.localeCompare(b)),
      objTypeForFilters: onjTypeForFilters.sort((a, b) => a.localeCompare(b)),
      makesForFilters: makesForFilters.sort((a, b) => a.localeCompare(b)),
      incidentStatusForFilters: incidentStatusForFilters.sort((a, b) => a.localeCompare(b)),
      conrtactStatusesForFilters: contractStatusesForFilters.sort((a, b) => a.localeCompare(b)),
      damageTypesForFilters: damageTypesForFilters.sort((a, b) => a.localeCompare(b)),
      damageCounters,
      damageCountersFiltered: damageCounters,
    })
  }

  private async getReportData(attempt = 0, maxRetries = 3) {
    const { selectedTenantId } = this.state
    const tenantReport = selectedTenantId
      ? this.state.availableReports.find(
          (r) =>
            isDatabaseReport(r) &&
            r.name.toLowerCase().includes('schadens') &&
            r.tenantId?.toLowerCase() === selectedTenantId.toLowerCase()
        )
      : undefined

    if (!tenantReport) {
      this.setState({
        showWarningModal: true,
        loading: false,
      })
      return
    }

    try {
      window.clearTimeout(this.pollingTimeoutId)
      this.setState({ loading: true })
      const result = await this.props.getReport(tenantReport.id!, false)
      if (isDatabaseReport(result)) {
        this.setState({ report: result })
        if (!result.data && result.running && attempt < maxRetries) {
          this.pollingTimeoutId = window.setTimeout(() => {
            this.getReportData(attempt + 1, maxRetries)
          }, 15000)
        }
      }
    } finally {
      this.setState({ loading: false })
    }
  }

  private getTenantsList() {
    const { tenants, availableReports } = this.state

    const sourceTenants = tenants.filter((t) => {
      return availableReports.some(
        (r) =>
          isDatabaseReport(r) &&
          r.name.toLowerCase().includes('schadens') &&
          r.tenantId?.toLowerCase() === t.id.toLowerCase()
      )
    })

    this.setState({
      sourceTenants: sourceTenants,
      selectedTenantId: sourceTenants.at(0)?.id,
    })
  }
}

function mapStateToProps({ appData }: State) {
  return {
    currentUser: appData.currentUser,
  }
}

const mapDispatchToProps = {
  getAvailableReports: wrapQuery(() => reportsApi.endpoints.getReports.initiate()),
  getReport: wrapQuery((reportId: string, force?: boolean) =>
    reportsApi.endpoints.getReport.initiate({ reportId, force })
  ),
  loadTenants: wrapQuery(() => customersApi.endpoints.getTenants.initiate()),
}

const connector = connect(mapStateToProps, mapDispatchToProps)
// eslint-disable-next-line react-refresh/only-export-components
export default connector(withTranslation('common')(withRouter(CarDamages)))
